import { useApp } from 'contexts/app';
import { useTranslation } from 'react-i18next';
import { UploadFileDialog } from 'shell/components';
import { PREVIEW_SUBMISSIONS_LIMIT, SUBMISSION_ALLOWED_FILE_TYPES } from 'utils/constants';

const UploadPreviewSubmissionsDialog = ({ open, onClose, onClick }) => {
    const { currentAssignment } = useApp();
    const { t } = useTranslation('assignment');

    const numUploadsRemaining = PREVIEW_SUBMISSIONS_LIMIT - (currentAssignment.preview_files?.length || 0);

    const handleClickUpload = (files) => {
        onClick(
            files.map((file) => ({
                ...file,
                is_preview_up_to_date: false,
            }))
        );
        onClose();
    };

    return (
        <UploadFileDialog
            allowedFileTypes={SUBMISSION_ALLOWED_FILE_TYPES}
            description={t(
                'submission.upload-file-description-best-results',
                'For best results, we recommend uploading examples of a high, medium and low-scoring submission. Please make sure each file is no larger than 500MB.'
            )}
            max={numUploadsRemaining}
            open={open}
            title={t('submission.upload-remaining-submissions', 'Upload {{count}} Remaining Submissions', {
                count: numUploadsRemaining,
            })}
            uploadButtonText={t('submission.start-processing', 'Start Processing')}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
};

export default UploadPreviewSubmissionsDialog;
